export const p80_base = [
  ['P80 M1 M2 动力电机', '电子件'],
  ['P40 V40 P80 飞控', '电子件'],
  ['P80 电调', '电子件'],
  ['P80升级版 M3/M4动力电机', '电子件'],
  ['P40 V40 P80 水泵盒', '电子件'],
  ['P40 V40 P80 摇摆雷达', '电子件'],
  ['2019/2020款 P40 V40 P80 地形模块', '电子件'],
  ['V40/P80 M3 M4 动力电机', '电子件'],
  ['P40 V40 P80 睿图', '电子件'],
  ['P40 V40 P80 航灯', '电子件'],
  ['P20/P30 19/20款 P40 V40 P80 UPS模块', '电子件'],
  ['P80 蠕动泵D', '电子件'],
  ['P80 3、4号机臂喷头航灯连接线', '电子件'],
  ['P80 蠕动泵C', '电子件'],
  ['P80 XP多频RTK天线-R', '电子件'],
  ['P80 XP多频RTK天线-L', '电子件'],
  ['21款智能药箱传感器模块（35L）', '电子件'],
  ['V40 P80 尾灯', '电子件'],
  ['P80播撒甩盘电机', '电子件'],
  ['P40 V40 P80 FPV相机', '电子件'],
  ['P80升级版 甩盘电机', '电子件'],
  ['P40 V40 P80 向上雷达', '电子件'],
  ['P80 1、2号机臂航灯连接线', '电子件'],
  ['P80播撒绞龙减速电机', '电子件'],
  ['P80播撒检测模块', '电子件'],
  ['P80 集线板', '电子件'],
  ['P100 P80升级版负载集线板睿播连接线组件', '电子件'],
  ['P80 XP双频天线-R', '电子件'],
  ['P80 XP 双频天线-L', '电子件'],
  ['P80 1、2号机臂电调转接线-电调端', '电子件'],
  ['P80播撒检测模块发射接收组件', '电子件'],
  ['P80 3、4号机臂电调转接线-电调端', '电子件'],
  ['P40 V40 P80 探照灯', '电子件'],
  ['P80  1、2号机臂航灯连接线', '电子件'],
  ['V40 P40 P80 4G片状天线', '电子件'],
  ['P80升级版 绞龙电机减速组', '电子件'],
  ['P80 电调信号延长线-机身端', '电子件'],
  ['P80 蠕动泵-尾插Y型信号线', '电子件'],
  ['P80升级版 料箱雷达', '电子件'],
  ['V40 P80料箱检测控制板组件', '电子件'],
  ['V50 P100 P80升级版负载集线板PCBA', '电子件'],
  ['P80 水泵板-航灯-机身端连接线', '电子件'],
  ['P80 水泵板-喷头-机身端连接线', '电子件'],
  ['P80 蠕动泵-水泵板延长线', '电子件'],
  ['V40 P80飞控-中央集线板', '电子件'],
  ['P80下料口对射灯组件', '电子件'],
  ['P80升级版 负载转接线', '电子件'],
  ['V50 P100 P80升级版 甩盘电机线', '电子件'],
  ['P40 V40 P80 航灯-机臂连接线', '电子件'],
  ['P40 V40 P80 喷头-机臂连接线', '电子件'],
  ['P80通讯电源线', '电子件'],
  ['P80料高检测线', '电子件'],
  ['P80出料检测线', '电子件'],
  ['P80 绞龙电机-水泵板连接线', '电子件'],
  ['P80 甩盘电机-水泵板连接线', '电子件'],
  ['P80升级版 负载集线板-12PIN转接件', '电子件'],
  ['P80料箱检测发射板 PCBA', '电子件'],
]
export const p80_advance: string[][] = []
